import { render } from "./AppTerms.vue?vue&type=template&id=f79dfaa4&scoped=true"
import script from "./AppTerms.vue?vue&type=script&lang=js"
export * from "./AppTerms.vue?vue&type=script&lang=js"

import "./AppTerms.vue?vue&type=style&index=0&id=f79dfaa4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f79dfaa4"]])

export default __exports__